import { createAction } from 'src/lib/createAction';
import { CourseType } from 'src/common/models/courseType';

export const homepageActions = {
  setViewType: createAction('homepageViewTypeActions/setViewType')<CourseType>(),
} as const;
